import { EllipsisVertical, Trash } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { TableCell, TableRow } from '@/components/ui/table';

import { useRegion, usePutRegion } from '@/data/region';

const RegionTaxRow = ({ regionTaxes, regionTax, regionId }) => {
  const region = useRegion(regionId);
  const putRegion = usePutRegion();

  const handleDeleteRegionTax = async () => {
    const filteredTaxes = regionTaxes.filter((tax) => tax.id !== regionTax.id);
    const newRegionTaxes = filteredTaxes.map((tax) => tax.tax.id);
    await putRegion(regionId, { taxes: newRegionTaxes });
    region.mutate();
  };

  const formatRate = (rate) => `${(rate / 100).toFixed(2)}%`;

  return (
    <>
      <TableRow>
        <TableCell className="py-2">{regionTax.tax.name}</TableCell>
        <TableCell className="py-2">{regionTax.tax.label}</TableCell>
        <TableCell className="py-2 text-right">
          {formatRate(regionTax.tax.rate)}
        </TableCell>
        <TableCell className="text-right py-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="icon" size="icon" aria-label="Open menu">
                <EllipsisVertical size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuLabel>{regionTax.tax.label}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className="text-destructive"
                onClick={handleDeleteRegionTax}
              >
                <Trash className="mr-2 h-4 w-4" />
                Delete Tax
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>
    </>
  );
};

export default RegionTaxRow;
